module.exports = __webpack_public_path__ + "img/jimmy.564dd517.jpg";